module.exports = __webpack_public_path__ + "img/depthMap-bomber220.65c0856a.png";